// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__1JR79","headerIcon":"header_headerIcon__3fytE","headerText":"header_headerText__1JHaE"};